module.exports = __webpack_public_path__ + "static/media/Arbitrum_HorizontalLogo.42f6f7e2.svg";